import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { closeSnackbar } from '../../../redux/slices/snackbarSlice'; // Adjust the import path

export default function CustomizedSnackbars() {
  const dispatch = useDispatch();
  const { open, title, subtitle, duration, severity, position } = useSelector((state) => state.snackbar);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(closeSnackbar());
  };

  return (
      <Snackbar open={open} autoHideDuration={duration} onClose={handleClose} anchorOrigin={position} sx={{zIndex: 2000000}}>
        <Alert
          onClose={handleClose}
          severity={severity} // Dynamically set severity
          variant="filled"
          sx={{ width: '100%' }}
        >
          {title} {subtitle}
        </Alert>
      </Snackbar>
  );
}
